define("shared/components/shared/post/secondary/caption-writer/loader", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--modalHeader tCW--modalHeader">
    <Shared::LoadingSpinner />
  </div>
  */
  {
    "id": "l5vKWo5i",
    "block": "[[[10,0],[14,0,\"o--modalHeader tCW--modalHeader\"],[12],[1,\"\\n  \"],[8,[39,0],null,null,null],[1,\"\\n\"],[13]],[],false,[\"shared/loading-spinner\"]]",
    "moduleName": "shared/components/shared/post/secondary/caption-writer/loader.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});